import { DateTime } from 'luxon';

import { InitialValues } from 'forms/types';

import { BasicsFormValues } from '../form/types';
import { GetBasicsQuery } from '../graphql/GetSurveyBasics';

const decodeYear = (datetime?: string | null) =>
  datetime ? DateTime.fromISO(datetime).year : null;

const buildInitialValues = (data?: GetBasicsQuery): InitialValues<BasicsFormValues> => {
  const surveyBasics = data?.surveyBasics;
  const surveyOccupation = data?.surveyOccupation;

  return {
    dateOfBirth: surveyBasics?.dateOfBirth,
    gender: surveyBasics?.gender,
    stateId: surveyBasics?.stateId,
    annualIncomeBeforeCompany: surveyOccupation?.annualIncomeBeforeCompany,
    atLeast30HoursAWeek: surveyOccupation?.atLeast30HoursAWeek,
    becameOwnerAt: decodeYear(surveyOccupation?.becameOwnerAt),
    companyFoundedAt: decodeYear(surveyOccupation?.companyFoundedAt),
    corporateStructure: surveyOccupation?.corporateStructure,
    disabilityInsuranceSource: surveyOccupation?.disabilityInsuranceSource,
    disabilityInsuranceStatus: surveyOccupation?.disabilityInsuranceStatus,
    employerPaysPremium: surveyOccupation?.employerPaysPremium,
    existingCoverage: surveyOccupation?.existingCoverage,
    intendToReplace: surveyOccupation?.intendToReplace,
    job: surveyOccupation?.job
      ? {
          label: surveyOccupation.job.title,
          value: surveyOccupation.job.id,
          subLabel: surveyOccupation.job.group,
        }
      : null,
    numberOfEmployees: surveyOccupation?.numberOfEmployees,
    numberOfPartners: surveyOccupation?.numberOfPartners,
    ownershipStake: surveyOccupation?.ownershipStake,
    selfEmployed: surveyOccupation?.selfEmployed,
  };
};

export default buildInitialValues;
